import { useQuery } from "@apollo/react-hooks";
import ApartmentIcon from "@material-ui/icons/Apartment";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import BathtubOutlinedIcon from "@material-ui/icons/BathtubOutlined";
import ComputerOutlinedIcon from "@material-ui/icons/ComputerOutlined";
import DriveEtaOutlinedIcon from "@material-ui/icons/DriveEtaOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import InboxOutlinedIcon from "@material-ui/icons/InboxOutlined";
import KeyboardOutlinedIcon from "@material-ui/icons/KeyboardOutlined";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import RemoveOutlinedIcon from "@material-ui/icons/RemoveOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import WeekendOutlinedIcon from "@material-ui/icons/WeekendOutlined";
import gql from "graphql-tag";
import {
  GetTags as GetTagsGenerated,
  GetTagsVariables as GetTagsVariablesGenerated,
  GetTags_tomTags as TomTagsGenerated,
} from "core/queries/__generated__/GetTags";

export enum TagTypes {
  Squad = "Squad",
  Global = "Global",
}

export enum TagSubtypes {
  // Squad
  Dispatch = "Dispatch",
  ExternalHousekeeping = "External Housekeeping",
  GET = "GET",
  InternalHousekeeping = "Internal Housekeeping",
  IT = "IT",
  Hotel = "Hotel",
  Landlord = "Landlord",
  Maintenance = "Maintenance/PM",
  Onboarding = "Onboarding",
  Procurement = "Procurement",
  Unset = "Unset",
  Warehouse = "Warehouse",

  // Global
  ArrivalWalk = "Arrival Walk",
  Collateral = "Collateral",
  HKReplacement = "HK replacement",
  LostAndFound = "Lost and found",
  RetailReplacment = "Retail replacement",
  Packages = "Packages",
  SecurityDeposits = "Security deposits",
  SpecialOccasion = "Special occasion",
  QA = "QA",
}

export const TagsToIcons = (name: string) => {
  switch (name) {
    case TagSubtypes.Dispatch:
      return ComputerOutlinedIcon;
    case TagSubtypes.IT:
      return KeyboardOutlinedIcon;
    case TagSubtypes.Landlord:
      return HomeOutlinedIcon;
    case TagSubtypes.Onboarding:
      return AssignmentOutlinedIcon;
    case TagSubtypes.Procurement:
      return InboxOutlinedIcon;
    case TagSubtypes.GET:
      return PhoneOutlinedIcon;
    case TagSubtypes.InternalHousekeeping:
      return BathtubOutlinedIcon;
    case TagSubtypes.ExternalHousekeeping:
      return DriveEtaOutlinedIcon;
    case TagSubtypes.Maintenance:
      return SettingsOutlinedIcon;
    case TagSubtypes.Warehouse:
      return WeekendOutlinedIcon;
    case TagSubtypes.Hotel:
      return ApartmentIcon;
    case TagSubtypes.Unset:
      return RemoveOutlinedIcon;
    default:
      return null;
  }
};

export const TagsToColors = (name: string) => {
  switch (name) {
    case TagSubtypes.ArrivalWalk:
      return "red";
    case TagSubtypes.Collateral:
      return "orange";
    case TagSubtypes.HKReplacement:
      return "yellow";
    case TagSubtypes.LostAndFound:
      return "yellowLight";
    case TagSubtypes.Packages:
      return "green";
    case TagSubtypes.RetailReplacment:
      return "greenLight";
    case TagSubtypes.SecurityDeposits:
      return "greenDark";
    case TagSubtypes.SpecialOccasion:
      return "blueA";
    case TagSubtypes.QA:
      return "blue2";
    default:
      return "grayA";
  }
};

// Queries
export interface TomTags extends TomTagsGenerated {}
export interface GetTagsResponse extends GetTagsGenerated {}
export interface GetTagsVariables extends GetTagsVariablesGenerated {}

export const getTags = gql`
  query GetTags($tagType: String!) {
    tomTags(tagType: $tagType) {
      id
      name
      tagType
    }
  }
`;

export interface UseGetTagsQueryOptions {
  variables: GetTagsVariables;
}
export const useGetTagsQuery = ({ variables }: UseGetTagsQueryOptions) =>
  useQuery<GetTagsResponse, GetTagsVariables>(getTags, {
    fetchPolicy: "cache-and-network",
    variables,
  });
